import { api } from './api';

const makeRoleHeaders = (userRoleUuid) => {
    if (!userRoleUuid) {
        throw new Error('Missing active user role UUID.');
    }

    return {
        'USER-ROLE': userRoleUuid
    };
};

export const listDevices = async ({
    userRoleUuid,
    caregiverRoleUuid,
    deviceTypes,
    paginationLimit,
    paginationToken
} = {}) =>
    api.get('/devices', {
        headers: {
            ...makeRoleHeaders(userRoleUuid),
            ...(caregiverRoleUuid ? { 'CVP-QUERY-CAREGIVER': caregiverRoleUuid } : {}),
            ...(Array.isArray(deviceTypes) && deviceTypes.length > 0
                ? { 'CVP-QUERY-DEVICE-TYPE': JSON.stringify(deviceTypes) }
                : {}),
            ...(paginationLimit ? { 'PAGINATION-LIMIT': paginationLimit } : {}),
            ...(paginationToken ? { 'PAGINATION-TOKEN': paginationToken } : {})
        }
    });

export const searchDevices = async ({
    userRoleUuid,
    query,
    caregiverRoleUuid,
    deviceTypes,
    paginationLimit,
    paginationToken
} = {}) =>
    api.post(
        '/devices/search',
        { query },
        {
            headers: {
                ...makeRoleHeaders(userRoleUuid),
                ...(caregiverRoleUuid ? { 'CVP-QUERY-CAREGIVER': caregiverRoleUuid } : {}),
                ...(Array.isArray(deviceTypes) && deviceTypes.length > 0
                    ? { 'CVP-QUERY-DEVICE-TYPE': JSON.stringify(deviceTypes) }
                    : {}),
                ...(paginationLimit ? { 'PAGINATION-LIMIT': paginationLimit } : {}),
                ...(paginationToken ? { 'PAGINATION-TOKEN': paginationToken } : {})
            }
        }
    );

export const fetchDevice = async ({ userRoleUuid, deviceUuid } = {}) =>
    api.post(
        '/devices/fetch',
        { device: deviceUuid },
        {
            headers: makeRoleHeaders(userRoleUuid)
        }
    );

export const createDeviceAdmin = async ({ userRoleUuid, payload } = {}) =>
    api.post('/devices/admin', payload, {
        headers: makeRoleHeaders(userRoleUuid)
    });

export const deleteDeviceAdmin = async ({ userRoleUuid, deviceUuid } = {}) =>
    api.delete('/devices/admin', {
        headers: makeRoleHeaders(userRoleUuid),
        data: { device: deviceUuid }
    });

export const assignDevice = async ({ userRoleUuid, deviceUuid, caregiverRoleUuid } = {}) =>
    api.post(
        '/devices/assign',
        {
            device: deviceUuid,
            caregiver: caregiverRoleUuid
        },
        {
            headers: makeRoleHeaders(userRoleUuid)
        }
    );

export const unassignDevice = async ({ userRoleUuid, deviceUuid } = {}) =>
    api.delete('/devices/assign', {
        headers: makeRoleHeaders(userRoleUuid),
        data: { device: deviceUuid }
    });

export const registerDeviceAccess = async ({ userRoleUuid, deviceUuid, parameters } = {}) =>
    api.post(
        '/devices/register',
        {
            device: deviceUuid,
            parameters
        },
        {
            headers: makeRoleHeaders(userRoleUuid)
        }
    );
